import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function OtherValueDialog({ otherField, otherValue, setOtherValue, onSubmit, onClose }) {
  return (
    <Dialog open={!!otherField} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle>Add New Value</DialogTitle></DialogHeader>
        <p className="text-sm text-gray-500">Enter a value not in the master list.</p>
        <Input
          value={otherValue}
          onChange={e => setOtherValue(e.target.value)}
          placeholder="Enter value..."
          className="h-11"
          data-testid="other-value-input"
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={onSubmit} className="bg-amber-600 hover:bg-amber-700" data-testid="submit-other-btn">Add</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
